import { CoefficientsPerWorkerClass } from 'constants/CoefficientsPerWorkerclass';
import { PlanningInThePastState } from 'constants/PlanningInThePastState';
import {
  IPlanningInThePastEntry,
  IPlanningInThePastWorkerClassState,
} from 'types/contract-compliance/IContractCompliance';
import { WORKER_CLASSES } from './constants';

export type WorkerClassStates = Record<CoefficientsPerWorkerClass, PlanningInThePastState>;

/** A state for every worker class; one the entry does not hold (or a role never configured) was never granted. */
export const buildStates = (entry?: IPlanningInThePastEntry | null): WorkerClassStates =>
  WORKER_CLASSES.reduce(
    (states, workerClass) => ({
      ...states,
      [workerClass]:
        entry?.workerClassStates.find(state => state.workerClass === workerClass)?.state ??
        PlanningInThePastState.NOT_ALLOWED,
    }),
    {} as WorkerClassStates,
  );

export const toWorkerClassStates = (states: WorkerClassStates): IPlanningInThePastWorkerClassState[] =>
  WORKER_CLASSES.map(workerClass => ({ workerClass, state: states[workerClass] }));
